import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation()
  // Braces matter: since Chrome ~149 window.scrollTo returns a Promise, and an
  // effect returning it makes React throw "destroy is not a function" on cleanup.
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

export default ScrollToTop
